export default "__VITE_ASSET__2b4f0bff__"